export enum AssetTypeEnum {
  Luminaire = 2,
  Sensor = 1,
  Gateway = 3,
}

export enum AssetStatus {
  OFFLINE = "Offline",
  ONLINE = "Online",
  FAULT = "Fault",
  INITIAL = "Initial",
}

export interface AssetFilterValues {
  tc: {
    tcCode: string;
    tcName: string;
  };
  site: {
    siteCode: string | null;
    siteName: string | null;
  };
  block: {
    blockCode: string | null;
    blockName: string | null;
  };
  level: {
    levelCode: string | null;
    levelName: string | null;
  };
}

export enum RetentionPolicyEnum {
  RETAIN_ASSETS_NOT_IN_FILE = 1,
  ONLY_RETAIN_ASSETS_IN_FILE = 2,
}
